<script lang="ts" setup>
/* We can here add slots for icon (like loading button or whatever) 
  or we can wrap primeVue button with pt options
*/
const props = defineProps<{
  content: {
    tKey: string
    action: boolean
    isLast: boolean
  }
  close: () => void
}>()
const emit = defineEmits(['close'])
const { t } = useLocale()

const onClose = (type: 'next' | 'finish' | 'close' = 'close') => {
  // emit close to parent
  emit('close')
  // emit events bus
  useEvent(`popper:event`, { type })
  props.close()
}
</script>

<template>
  <div class="rounded bg-mcd-onboardingTip p-4 text-white shadow-elevation-down">
    <!-- Header -->
    <div class="mb-2 flex flex-row items-center justify-between gap-4">
      <p class="text-sm font-bold">{{ t(`${content.tKey}.title`, { pickup: t('common.MOP') }) }}</p>
      <CloseIcon width="10" height="10" fill="#FFFFFF" @click="() => onClose()" />
    </div>
    <!-- Content -->
    <p
      v-dompurify-html="t(`${content.tKey}.description`, { pickup: t('common.MOP') })"
      class="prose mb-2 w-[12rem] text-xs font-normal text-white"
    ></p>

    <!-- Actions -->
    <div v-if="content.action" class="flex flex-row">
      <button
        class="ml-auto mt-2 rounded border-none bg-white px-6 py-[6px] text-2xs font-bold text-mcd-onboardingTip"
        @click="() => onClose(content.isLast ? 'finish' : 'next')"
      >
        {{ t('onboarding.next') }}
      </button>
    </div>
  </div>
</template>
